module.exports = __webpack_public_path__ + "static/media/sparash.b490d11e.png";